import { Injectable } from '@angular/core';
// import * as urlData from './configs/http-urls.json'
import { AppSettings } from './app-settings.config';

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class HttpUrlConfig {
    constructor(private appSettings: AppSettings) {
    }

    urlData = {
        "urls": [{
          "appid": "portal",
          "event": "Addlead",
          "url": "lead/save",
          "version": "1.0.0",
          "action": null
        }]
      }

    getUrl(appid, event, version, action?) {
        const data = this.urlData.urls;

        var matachedUrlForEvent = data.filter(url => {
            return (url.action != null &&
                url.action === action &&
                url.appid === appid &&
                url.event === event &&
                url.version === version) 
                ||
                (url.appid === appid &&
                url.event === event &&
                url.version === version)
        })

        return matachedUrlForEvent[0].url
    }
}
